import styled from 'styled-components';
import {Space} from 'antd';

const StyledOverviewRightPanel = styled(Space)`
  & > .ant-space-item {
    display: flex;

    .ant-card {
      width: 100%;
    }
  }

  .ant-card-head {
    min-height: 40px;
  }
`;


export {
  StyledOverviewRightPanel
}
